import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { UserRedditOverviewCSS } from './UserRedditOverviewCSS.styled'
import { DateTime } from 'luxon'
import { Link } from 'components/Atoms/Link'
import { currencyFormatter } from 'utils'

export const UserRedditOverview = ({ userPublicData, isPending }) => {
  const { overviewData, redditData } = userPublicData
  const dt = DateTime.fromMillis(redditData?.created * 1000)
  const formattedDate = dt.toFormat('MMMM dd, yyyy')
  return (
    <UserRedditOverviewCSS>
      <div className='reddit_info_wrapper'>
        <div className='content column'>
          <div className='subtitle' id='reddit-subtitle'>
            Reddit User
          </div>
          <div className='reddit_content'>
            <div className='reddit_url'>
              <SingleDataLoader
                loading={isPending}
                data={
                  <Link
                    href={`https://www.reddit.com/user/${redditData?.name}/`}
                  >
                    {redditData?.name}
                  </Link>
                }
              />
            </div>
            <div className='reddit_description'>
              You are now connected as a Reddit user. You may unlink your Reddit
              account via the button below.
            </div>
            <div className='reddit_stats-main'>
              <div className='reddit_stat-karma'>
                <div className='title'>Karma</div>
                <div className='value'>
                  <SingleDataLoader
                    loading={isPending}
                    data={redditData?.totalKarma}
                  />
                </div>
              </div>
              <div className='reddit_stat-cakeday'>
                <div className='title'>Cake Day</div>
                <div className='value'>
                  <SingleDataLoader loading={isPending} data={formattedDate} />
                </div>
              </div>
            </div>

            {/* <div className='grid-content reddit_stats-global'>
              <label className='title'>First seen in WSB</label>
              <label className='value'>10 months ago</label>

              <label className='title'>Total submissions</label>
              <label className='value'>98</label>

              <label className='title'>Total comments</label>
              <label className='value'>643</label>

              <label className='title'>Account age</label>
              <label className='value'>2.5 years</label>
            </div> */}
          </div>
        </div>
        <div className='content column'>
          <div className='subtitle'>Leveraged Game Stats</div>

          <div className='grid-content stats'>
            {/* <!-- ROW --> */}
            <label className='title'>Total Bids</label>
            <label className='value'>
              <SingleDataLoader
                loading={isPending}
                data={overviewData?.totalBids}
              />
            </label>
            {/* <!-- ROW --> */}
            <label className='title'>Total amount bid</label>
            <label className='value'>
              <SingleDataLoader
                loading={isPending}
                data={currencyFormatter(overviewData?.totalAmountBid)}
              />
            </label>
            {/* <!-- ROW --> */}
            <label className='title'>Total profit</label>
            <label className='value'>
              <SingleDataLoader
                loading={isPending}
                data={currencyFormatter(overviewData?.totalProfit)}
              />
            </label>
            {/* <!-- ROW --> */}
            <label className='title'>Total ROI</label>
            <label className='value'>
              <SingleDataLoader
                loading={isPending}
                data={currencyFormatter(overviewData?.totalRoi)}
              />
            </label>
            {/* <!-- ROW --> */}
            <label className='title'>
              Largest & most profitable single bid
            </label>
            <label className='value'>
              <SingleDataLoader
                loading={isPending}
                data={currencyFormatter(overviewData?.largestBid)}
              />
            </label>
          </div>
        </div>
      </div>
    </UserRedditOverviewCSS>
  )
}
